import { ICardNumberStateUpdateAction } from './types';
import { ICardNumberState } from '../types';
import { AT_STATE_UPDATE } from './constants';

export const cardNumberStateUpdateAction = (state: Partial<ICardNumberState>): ICardNumberStateUpdateAction => ({
    type: AT_STATE_UPDATE,
    state
})
